module.exports = __webpack_public_path__ + "img/avatar_frame.5c08db81.png";